import { BKJCenteredDialog } from 'components/BKJCenteredDialog';
import { RemovePositionDialogProps } from 'pages/Settings/pages/LocationSettings/PositionsAllocation/RemovePositionDialog/RemovePositionDialog.types';
import {
  RemovePositionDialogFormProvider,
  useRemovePositionDialogFormContext,
} from 'pages/Settings/pages/LocationSettings/PositionsAllocation/RemovePositionDialog/RemovePositionDialog.form.context';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

const RemovePositionDialogView: FC<RemovePositionDialogProps> = ({
  isRemovePositionConfirmationOpen,
  setIsRemovePositionConfirmationOpen,
}) => {
  const { t } = useTranslation();
  const { handleRemovePosition, communityName } = useRemovePositionDialogFormContext();
  return (
    <BKJCenteredDialog
      isOpen={isRemovePositionConfirmationOpen}
      variant="Danger"
      title={t('dialog:REMOVE_POSITION_CONFIRMATION')}
      text={t('dialog:REMOVE_POSITION_MESSAGE', { communityName })}
      cancelLabel={t('auth:CANCEL')}
      actionLabel={t('auth:CONFIRM')}
      onAction={() => {
        setIsRemovePositionConfirmationOpen(false);
        return handleRemovePosition();
      }}
      onCancel={() => setIsRemovePositionConfirmationOpen(false)}
      onClose={() => setIsRemovePositionConfirmationOpen(false)}
    />
  );
};

export const RemovePositionDialog: FC<RemovePositionDialogProps> = (props) => {
  return (
    <RemovePositionDialogFormProvider {...props}>
      <RemovePositionDialogView {...props} />
    </RemovePositionDialogFormProvider>
  );
};
